import React from 'react'

import { checkPermission } from 'helpers/helpers';

import ChequeA4 from './ChequeA4';
import Cheque80 from './Cheque80';
import ChequeWork from './ChequeWork';
import ChequeWorkA4 from './ChequeWorkA4';
import ChequeShipment80 from './ChequeShipment80';

function Cheque({ data = { products: [] }, printChequeRef, show = false }) {

	/* YUK XATI (SMZ «Отгрузка» andozasi, 80mm) — omborchi Kengashdan chiqaradi
	   (2026-08-26). `shipment` bayrog'ini FAQAT Board.js::printShipDoc qo'yadi;
	   boshqa hamma oqim (kassa, A4, ish topshirig'i) avvalgidek qoladi. */
	if (data.shipment) {
		return <ChequeShipment80 data={data} printChequeRef={printChequeRef} show={show} />
	}

	// Sex monobloki (Profnastil/Aksessuar/Tunukafon) — ISH TOPSHIRIG'I: faqat o'z
	// bo'limining qatorlari, narxsiz. `work_dept` ni Board.js faqat ROLE_WORKSHOP
	// uchun qo'yadi; qolgan hamma joyda odatdagi chek chiqadi (A4 ham o'zgarmaydi).
	//
	// ⚠️ `length > 0` SHARTI ATAYLAB YO'Q. Ustaga bo'lim biriktirilmagan bo'lsa
	// (`users_product_types` da qator yo'q) `work_dept` BO'SH massiv keladi. Uzunlikni
	// tekshirsak — narxli to'liq chek chiqib ketardi (fail-open), ya'ni bu maket aynan
	// nimadan saqlash uchun yozilgan bo'lsa — o'shani qilardi. Massivning O'ZI
	// «bu sex foydalanuvchisi» degani; bo'sh bo'lsa bo'sh topshiriq chiqsin (fail-closed),
	// sozlamadagi xato shunda ko'rinib ham qoladi.
	const isWorkOrder = Array.isArray(data.work_dept) && !data.a4

	/* TUNUKAFON SEXI → A4 VARAQ (2026-08-13, foydalanuvchi talabi).
	   Tunukafon buyurtmasida bitta chekда 15 tagacha har xil profil bo'ladi;
	   80 mm tasmada har biri chizmasi bilan ketma-ket chiqsa qog'oz IKKI
	   METRGA cho'ziladi va usta uni stolga yoyolmaydi. Ustalar hozir buni
	   qo'lda A4 ga 3 ustun qilib chizib olishadi — shuning bosma varianti.

	   ⚠️ `length > 0` SHART: bo'sh massivda `every()` TRUE qaytaradi
	      (JS qoidasi), ya'ni bo'lim biriktirilmagan ustaga ham tunukafon
	      varag'i chiqib ketardi. Yuqoridagi fail-closed mantiq buziladi.
	   ⚠️ Faqat SOF tunukafon ustasi: bo'limlari [5] bo'lsa. Aralash bo'lsa
	      (masalan [4,5]) 80 mm qoladi — u yerda bo'lim tasmalari bilan
	      ikkala sexning qatori bitta tasmada ketadi. */
	/* ⚠️ TARIF: faqat FULL (2026-08-13, korxona egasining qarori).
	   Bu varaqning butun ma'nosi CHIZMADA — 3 ustunli katak chizmasiz
	   oddiy ro'yxatga aylanadi va 80 mm tasmadan hech qanday afzalligi
	   qolmaydi. Chizma moduli (`sec.accessory_drawing`) allaqachon Full
	   tarifiga bog'langan (tariff_permissions), shuning uchun bu varaq
	   ham o'sha ruxsatga qarab beriladi — alohida ruxsat yaratilmadi.

	   Ruxsati yo'q tenantda tunukafon ustasi odatdagi 80 mm ish
	   topshirig'ini oladi (`ChequeWork`) — hech narsa yo'qolmaydi. */
	/* ⚠️ `isWorkOrder` EMAS, `Array.isArray(...)` — ATAYLAB (2026-08-14).
	   `isWorkOrder` ichida `!data.a4` bor: u 80 mm tasma o'rniga A4 so'ralganda
	   ish topshirig'idan chiqish uchun. Lekin BU VARAQNING O'ZI A4 — natijada
	   tunukafon ustasi «A4» tugmasini bosganda shart buzilib, u o'z varag'i
	   o'rniga NARXLI MIJOZ CHEKINI olardi (foydalanuvchi: «tunukafon rolida
	   A4 da chek raqami ko'rinmayapti» — aslida butunlay boshqa maket
	   chiqayotgan edi, sexga narx ham ko'rinib qolgan).
	   Sex xodimi qaysi tugmani bosmasin o'z varag'ini olishi kerak. */
	const workDept = Array.isArray(data.work_dept) ? data.work_dept.map(Number) : []
	const isTuniWorkOrder = Array.isArray(data.work_dept)
		&& workDept.length > 0
		&& workDept.every(d => d === 5)
		&& checkPermission('sec.accessory_drawing')

	return (
		<>
			{isTuniWorkOrder ?
				<ChequeWorkA4 data={data} printChequeRef={printChequeRef} show={show}></ChequeWorkA4>
				: isWorkOrder ?
				<ChequeWork data={data} printChequeRef={printChequeRef} show={show}></ChequeWork>
				: (data.a4 || show) ?
					<ChequeA4 data={data} printChequeRef={printChequeRef} show={show}></ChequeA4>
					:
					<Cheque80 data={data} printChequeRef={printChequeRef} show={show}></Cheque80>
			}
		</>
	)
}

export default Cheque